// Angular
import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';

// UI Components
import {ToastContainerComponent} from '@sms-ir/ui-components';

// App services
import {ThemeService} from '@app/core/services/theme.service';
import {GlobalBackdropComponent} from '@app/core/components/global-backdrop/global-backdrop.component';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    GlobalBackdropComponent,
    ToastContainerComponent,
  ],
  template: `
    <router-outlet></router-outlet>
    <app-global-backdrop/>
    <smsir-toast-container/>
  `,
})
export class AppComponent {
  private themeService = inject(ThemeService);
}
